addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('a.download-tickets')
  if (!btn) return

  let csv = 'Name,Tickets\n'

  document.querySelectorAll('tr.ticket').forEach(el => {
    csv += `${el.children[0].innerText},"${el.children[1].innerText}"\n`
  })

  const blob = new Blob([csv], { type: 'text/csv' })
  btn.href = window.URL.createObjectURL(blob)
})
